import dashboard from './reducers/dashboard/dashboardSlice';
import administer from './reducers/administer/administerSlice';
import careCoordinator from './reducers/careCoordinator/careCoordinatorSlice';

export default {
    careCoordinator: {
        reducer: careCoordinator,
    },
    dashboard: {
        reducer: dashboard,
    },
    administer: {
        reducer: administer,
    },
};
